import type { ButtonBaseProps } from '@mui/material/ButtonBase'
import React from 'react'

import * as S from './styles'

export const SquareButton = React.forwardRef(
  (
    { disabled, className, ...rest }: Omit<ButtonBaseProps, 'ref'>,
    ref: React.ForwardedRef<HTMLButtonElement>,
  ) => <S.ButtonBase disabled={disabled} className={className} disableRipple ref={ref} {...rest} />,
)

SquareButton.displayName = 'SquareButton'
